import { Component } from '@angular/core';
import {
  GedBaseComponent,
  IGedBaseComponent,
} from '../../../../../../core/base/components/ged-base/ged-base.component';
import { AuthService } from '../../../../../../core/services/auth.service';
import { GedService } from '../../../../admin/playground/docuware-playground/ged.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FileSaverService } from 'ngx-filesaver';
import { GED_CONFIG } from '../../../../../../core/enums/ged-type.enum';
import { EstablishmentService } from '../../establishment.service';
import { FeiColumn } from '../../../../../../core/base/interfaces/fei-column.interface';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EstablishmentModel } from '../../../../../../core/models/establishment.model';
import { ENUM_PERMISSIONS } from '../../../../../../core/enums/permission.enum';

@Component({
  selector: 'vex-establishment-details-documents',
  templateUrl: './establishment-details-documents.component.html',
  styleUrls: ['./establishment-details-documents.component.scss'],
})
export class EstablishmentDetailsDocumentsComponent
  extends GedBaseComponent<EstablishmentModel>
  implements IGedBaseComponent
{
  documentTypes = [
    "Attestation d'assurance",
    'Commissions de sécurité',
    'Identification entreprise',
    'Plan',
    'RIB',
    'Autres',
  ];

  feisColumns: Array<FeiColumn> = [
    { label: 'Nom du fichier', column: 'NOM_DU_DOCUMENT' },
    { label: 'Type de document', column: 'DOCUMENT_TYPE' },
    { label: 'Nombre de pages', column: 'DWPAGECOUNT' },
    { label: 'Date du dépôt', column: 'DATE_DU_DEPOT', type: 'date' },
    { label: '', column: 'btnToPrev', type: 'custom' },
    {
      label: '',
      column: 'actions',
      canUpdate: false,
      canDelete: this.authService.hasPermission(ENUM_PERMISSIONS.UPDATE_ESTABLISHMENT),
      canDownload: this.authService.hasPermission(ENUM_PERMISSIONS.READ_ESTABLISHMENT),
    },
  ];
  ENUM_PERMISSIONS = ENUM_PERMISSIONS;
  displayedColumns = [];
  loadingPreview = false;

  constructor(
    public service: EstablishmentService,
    public authService: AuthService,
    private gedService: GedService,
    public dialog: MatDialog,
    public fileSaver: FileSaverService,
  ) {
    super(GED_CONFIG.establishment, gedService, service, dialog, fileSaver);
    this.displayedColumns = this.feisColumns.map(x => x.column);
  }

  initForm() {
    this.form = new UntypedFormGroup({
      documentType: new UntypedFormControl(null, [Validators.required]),
      predikId: new UntypedFormControl(this.id, [Validators.required]),
    });

    this.loading = false;
  }

  afterUpload() {
    this.service.findById(this.id).subscribe();
  }

  afterDelete() {
    this.service.findById(this.id).subscribe();
  }
}
